import { render, staticRenderFns } from "./ProductSticker.vue?vue&type=template&id=06dcd64a&scoped=true&"
import script from "./ProductSticker.vue?vue&type=script&lang=js&"
export * from "./ProductSticker.vue?vue&type=script&lang=js&"
import style0 from "./ProductSticker.vue?vue&type=style&index=0&id=06dcd64a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06dcd64a",
  null
  
)

export default component.exports